import { useContext, useEffect } from 'react';

import { AppContext } from 'Context/AppContext';

import useFeesStore from './FeesStore';

const FeesStoreLoader = (): null => {
	const appContext = useContext(AppContext);
	const setFees = useFeesStore((store) => store.setFees);

	const isUser = Boolean(appContext?.state?.user);

	useEffect(() => {
		if (isUser) {
			void setFees();
		}
	}, [isUser, setFees]);

	return null;
};

export default FeesStoreLoader;
